export function delimit(str1, str2, delimiter) {
	return (
		str1 ? (str2 ? str1 + delimiter + str2 : str1) : str2
	);
}


// WEBPACK FOOTER //
// ./src/StringUtils.js